import {
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
} from "@mui/material";

interface ICensusRadioItem {
  label: string;
  value: string;
}

interface ICensusRadio {
  label: React.ReactNode;
  name?: string;
  value: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  options: ICensusRadioItem[];
  disabled?: boolean;
}

const CensusRadio = (props: ICensusRadio) => {
  const { label, name, value, onChange, options, disabled = false } = props;
  return (
    <FormControl>
      <FormLabel required>{label}</FormLabel>
      <RadioGroup value={value} row name={name} onChange={onChange}>
        {options.map((item) => (
          <FormControlLabel
            key={item.label}
            value={item.value}
            control={<Radio />}
            label={item.label}
            disabled={disabled}
          />
        ))}
      </RadioGroup>
    </FormControl>
  );
};

export default CensusRadio;
